import { httpAuth } from "@/api/httpAuth";

export const searchRequests = {
  search_omni: function ({ context, data } = {}) {
    return httpAuth.post("/v1/search/omni", { context, json: data }).json();
  },
};
